import { FC } from 'react'
import { StyleSheet, Text, View } from 'react-native'
import Logo from '../../../../assets/images/adaptee-gastro-logo.svg'
import { FontsEnum } from '../../../constants/fonts'

const MainLoader: FC = () => {
    return (
        <View style={styles.container}>
            <Logo viewBox="0 0 775 420" />
            <Text style={styles.text}>Načítám...</Text>
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        alignItems: 'center',
        justifyContent: 'center',
        flex: 1,
        backgroundColor: '#FFFFFF',
        paddingTop: 40,
    },
    text: {
        fontFamily: FontsEnum.RUBIK_400_REGULAR,
        fontSize: 21,
    },
})

export default MainLoader
